export default __webpack_public_path__ + "static/media/captainHat.658e63da.svg";